import React from 'react';
import Icon from '../../../components/AppIcon';
import TemplateTableRow from './TemplateTableRow';

const SortHeaderButton = ({ label, sortKey, columnKey, sortDir, onSortColumn, className = '' }) => {
  const active = sortKey === columnKey;
  return (
    <button
      type="button"
      onClick={() => onSortColumn(columnKey)}
      className={`inline-flex items-center gap-1.5 text-left text-xs font-semibold text-foreground font-caption uppercase tracking-wider hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded ${className}`}
    >
      <span>{label}</span>
      {active ? (
        <Icon
          name={sortDir === 'asc' ? 'ArrowUp' : 'ArrowDown'}
          size={14}
          className="shrink-0 text-primary"
        />
      ) : null}
    </button>
  );
};

const TemplateTable = ({
  templates,
  sortKey,
  sortDir,
  onSortColumn,
  onEdit,
  onCreateContract,
  onDelete,
  onDuplicate,
  onDownload,
  actionsDisabled = false,
}) => {
  return (
    <div className="bg-card border border-border rounded-xl shadow-elevation-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption">
                <SortHeaderButton
                  label="Nome"
                  columnKey="name"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption hidden md:table-cell">
                <SortHeaderButton
                  label="Data de Criação"
                  columnKey="createdAt"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-right text-xs font-semibold text-foreground uppercase tracking-wider font-caption">
                Ações
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {templates.map((template) => (
              <TemplateTableRow
                key={template.template_id}
                template={template}
                onEdit={onEdit}
                onCreateContract={onCreateContract}
                onDelete={onDelete}
                onDuplicate={onDuplicate}
                onDownload={onDownload}
                actionsDisabled={actionsDisabled}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TemplateTable;
